import { useState } from "react";
import { ArrowUpRight, Calendar, Clock, MapPin } from "lucide-react";
import TiltCard from "@/components/TiltCard";
import TournamentDetailsDialog, { formatTournamentDate } from "@/components/TournamentDetailsDialog";

export default function TournamentPreviewCard({ tournament, testId, detailsTestId, variant = "home" }) {
  const [tiltResetKey, setTiltResetKey] = useState(0);
  const isFull = variant === "full";
  const place = [tournament.location, tournament.city].filter(Boolean).join(" • ");
  const registrationLink = isFull && /^https?:\/\//i.test(tournament.registration_link || "")
    ? tournament.registration_link
    : null;
  const content = isFull ? (
    <>
      {tournament.featured && (
        <span className="mb-3 w-fit rounded-md bg-amber-500 px-2.5 py-1 text-xs font-semibold text-[#071A33]">Destaque</span>
      )}
      <h3 className="text-base font-semibold text-white">{tournament.name}</h3>
      <div className="mt-3 space-y-2 text-sm text-slate-300">
        <p className="flex items-center gap-2"><Calendar className="h-4 w-4 shrink-0 text-amber-400" aria-hidden="true" /><span className="font-mono">{formatTournamentDate(tournament.date)}</span></p>
        <p className="flex items-center gap-2"><Clock className="h-4 w-4 shrink-0 text-amber-400" aria-hidden="true" />{tournament.time || "A definir"}</p>
        <p className="flex items-center gap-2"><MapPin className="h-4 w-4 shrink-0 text-amber-400" aria-hidden="true" />{place || "A definir"}</p>
      </div>
      <div className="mt-4 flex flex-wrap gap-2 text-xs">
        {[tournament.modality, tournament.category, tournament.fee].filter(Boolean).map((value, index) => (
          <span key={`${index}-${value}`} className="rounded bg-white/5 px-2 py-1 text-slate-300">{value}</span>
        ))}
      </div>
      {tournament.info && <p className="mt-3 text-xs leading-relaxed text-slate-400">{tournament.info}</p>}
      <span className="mt-auto inline-flex items-center gap-1 pt-4 text-xs font-medium text-amber-300 transition-colors group-hover:text-amber-200">
        Ver detalhes <ArrowUpRight className="h-3.5 w-3.5" aria-hidden="true" />
      </span>
    </>
  ) : (
    <>
      <p className="flex items-center gap-2 text-xs font-medium uppercase tracking-wide text-amber-300">
        <Calendar className="h-4 w-4 shrink-0" aria-hidden="true" />
        {formatTournamentDate(tournament.date)} • {tournament.time || "A definir"}
      </p>
      <h3 className="mt-3 text-base font-semibold text-white">{tournament.name}</h3>
      <p className="mt-1 text-sm text-slate-300">
        {[tournament.city, tournament.modality].filter(Boolean).join(" • ")}
      </p>
      {tournament.info && <p className="mt-3 text-xs leading-relaxed text-slate-400">{tournament.info}</p>}
    </>
  );

  return (
    <TiltCard
      data-testid={testId}
      max={6}
      resetKey={tiltResetKey}
      className={`flex min-h-[176px] flex-col border border-amber-400/20 bg-[#0b2342]${isFull ? " sm:min-h-[290px]" : ""}`}
    >
      {isFull ? (
        <TournamentDetailsDialog tournament={tournament} onOpenChange={() => setTiltResetKey((key) => key + 1)}>
          <button
            type="button"
            data-testid={detailsTestId}
            aria-label={`Ver detalhes de ${tournament.name}`}
            className="group flex w-full flex-1 flex-col p-5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-amber-400 sm:p-6"
          >
            {content}
          </button>
        </TournamentDetailsDialog>
      ) : (
        <div className="flex w-full flex-1 flex-col p-5 sm:p-6">{content}</div>
      )}
      {registrationLink && (
        <a
          href={registrationLink}
          target="_blank"
          rel="noopener noreferrer"
          className="absolute bottom-5 right-5 z-10 text-xs font-medium text-amber-300 transition-colors hover:text-amber-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-400 sm:bottom-6 sm:right-6"
        >
          Inscrição <ArrowUpRight className="inline h-3.5 w-3.5" aria-hidden="true" />
        </a>
      )}
    </TiltCard>
  );
}
